export default __webpack_public_path__ + "static/media/Trans_sell.e1ab986e.svg";